export const ListingCompareSummaryBar = ({ onClear, onRemove, onReview, units }) => {
  return (
    <div className="fixed inset-x-0 bottom-[88px] z-50 px-3 md:bottom-6 md:px-6" data-testid="listing-detail-compare-summary-bar">
      <div className="mx-auto flex w-full max-w-4xl flex-col gap-4 rounded-[28px] border border-[#D4AF37]/35 bg-[#fffaf1]/95 p-4 shadow-[0_24px_80px_rgba(0,25,53,0.18)] backdrop-blur md:flex-row md:items-center md:justify-between md:p-5">
        <div className="min-w-0">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#8b6d16]" data-testid="listing-detail-compare-summary-count">
            {units.length === 1 ? "1 unit shortlisted" : `${units.length} units ready to compare`}
          </p>
          <div className="mt-3 flex flex-wrap gap-2">
            {units.map((unit, index) => (
              <div className="inline-flex items-center gap-3 rounded-full border border-[#D4AF37]/30 bg-white px-4 py-2 text-sm text-[#333333]" data-testid={`listing-detail-compare-summary-chip-${index + 1}`} key={`${unit.type}-${unit.index}`}>
                <span className="font-semibold text-[#001935]">{unit.type}</span>
                <span className="text-[#6b6252]">{unit.size} sqft · {unit.price}</span>
                <button className="rounded-full border border-[#D4AF37]/30 px-2 py-1 text-[11px] font-bold uppercase tracking-[0.16em] text-[#8b6d16] transition hover:bg-[#D4AF37]/10" data-testid={`listing-detail-compare-summary-remove-${index + 1}`} onClick={() => onRemove(unit.index)} type="button">
                  Remove
                </button>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-wrap gap-3">
          <button className="gold-button" data-testid="listing-detail-compare-summary-review-button" onClick={onReview} type="button">
            Review Compare
          </button>
          <button className="outline-button" data-testid="listing-detail-compare-summary-clear-button" onClick={onClear} type="button">
            Clear All
          </button>
        </div>
      </div>
    </div>
  );
};